import { Icon } from '#components'

export default (options: { name: string, class?: string, size?: string }) => h(Icon, options)
